export default __webpack_public_path__ + "static/hq12-cb30300b50187b6f205a3b6ddc701fbe.jpg";